import { Container } from "@mui/material";
import React from "react";

import { BusinessService } from "0.Mine/3.Interfaces/Services";

import TreatmentTable from "../Container/ServiceTable";

export interface ServicesFormUIProps {
  businessid: number;
  treatments: BusinessService[];
  onAdd: (treatment: BusinessService) => Promise<void> | void;
  onDelete: (index: number) => void;
  onReorder: (newTreatments: BusinessService[]) => void;
  onUpdate: (treatment: BusinessService) => void; // Add this prop
}

const ServicesFormUI: React.FC<ServicesFormUIProps> = ({
  businessid,
  treatments,
  onAdd,
  onDelete,
  onReorder,
  onUpdate, // Add this prop
}) => {
  return (
    <Container maxWidth="lg" sx={{ maxWidth: "100%!important" }}>
      <TreatmentTable
        businessid={businessid}
        treatments={treatments}
        onAdd={onAdd}
        onDelete={onDelete}
        onReorder={onReorder}
        onUpdate={onUpdate} // Pass the prop to TreatmentTable
      />
    </Container>
  );
};

export default ServicesFormUI;
